export default {"src":"/_next/static/media/image.fcb36e3b.svg","height":368,"width":390,"blurWidth":0,"blurHeight":0};